import sliderTestimonials from '../../../../../../src/js/modules/sliderTestimonials';

window.addEventListener('load', () => {
    sliderTestimonials.init();
});
